import {
  IEventTableExportParams,
  useAddEventTablesExportJobMutation
} from 'app/services/api/datamanagement/eventTableAttributes'
import { useExportJobContext } from 'common/contexts/useExportJobContext'
import { IExportJobContext } from 'common/contexts/types'

interface IDataExportButton {
  exportParams: IEventTableExportParams
  pendingText?: string
  defaultText?: string
  onExportClick?: (exportJob: IExportJobContext['exportJob']) => void
}

const DataExportButton = ({
  exportParams,
  pendingText = 'Exporting...',
  defaultText = 'Export Data',
  onExportClick
}: IDataExportButton) => {
  const [addEventTablesExportJob] = useAddEventTablesExportJobMutation()
  const { exportJob, isJobPending, createDataExportJob } = useExportJobContext()

  return (
    <button
      className={[
        'mt-6 px-8 py-3',
        'rounded bg-lighthouseBlue',
        'text-white',
        'disabled:opacity-30'
      ].join(' ')}
      onClick={() => {
        createDataExportJob(addEventTablesExportJob, exportParams)
        onExportClick?.(exportJob)
      }}
      disabled={
        exportJob.isFetching ||
        isJobPending ||
        // REVIEW: is this overly dependent on the data structure
        exportParams.eventTableList.length < 1
      }
    >
      <span className='uppercase'>
        {isJobPending ? pendingText : defaultText}
      </span>
    </button>
  )
}

export default DataExportButton
